import { Component, OnInit, ViewChild, OnDestroy, NgZone, AfterViewInit, ElementRef } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { UserService } from '../services/user.service';
import { ToastMessageOptions as Message } from 'primeng/api';
import { Store, select } from '@ngrx/store';
import * as fromStore from '../store';
import { Router } from '@angular/router';
import { DevicesService } from '../services/devices.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CryptoService } from '../services/crypto.service';
import { Confirm_button, environment, RECAPTCHA_V2_INVISIBLE_SITE_KEY } from '../../environments/environment';
import { MessageService } from 'primeng/api';
import { AccountService } from '../services/account.service';
import * as fromFeature from '../my-features';
import { PreferenceService } from '../services/preference.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SummaryService } from '../services/summary.service';
import { OAuthLoginMessage, CheckAuthOtpErrMsg, AuthOtpType, OAuthPurposeType, OAuthPlatformType } from '../shareModel';
import { AccountOauthParam, OauthLoginParam } from '../my-features/account/oauth.model';
// import { JwtHelperService } from '@auth0/angular-jwt';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';

// 2026-06-16 移除reCAPTCHA 供v1.10.4測試
// declare const grecaptcha: any;

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {
  // @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  public form: FormGroup;
  loginFail = false;
  reCAPTCHAFail = false;
  isLogging = false;
  LoginLocked = false;
  LoginLockedMessage: string;
  Confirm_button = Confirm_button;
  RegisterUrl = environment.cyberpowerUrl + '/account/registration';
  ForgetPasswordUrl = environment.cyberpowerUrl + '/account/forgot';
  DemoUrl = 'https://demo.cyberpower.com/';
  WebVersion = environment.WebVersion;
  isProd = environment.production;
  inputType = 'password';
  showPasswordIcon: Boolean = false;
  private componentDestroyed = new Subject();
  socialType: string;
  socialAccountCombineLimitAlert = false;
  socialAccountEmailAlert = false;
  socialEmailRegisterAlert = false;
  censoredEmail: any;
  socialEmailRegisterSetting = false;
  AuthOtpId: number;
  AuthOtp: number;
  AuthUserotp: string;
  TwoFactorAuthDialog = false;
  OTPLockDialog = false;
  OTPOvertime = false;
  errorMsg = '';
  OTPNumber: string;
  errorMsgByLock = false;
  OTPNumberSubmitDisabled = true;
  CountryOptions = [
    { label: TRANSLATE('Select Country'), value: null }
  ];
  Country = null;
  dialogSaveDirty = false;
  OauthEmail: string;
  AddOauthparam: AccountOauthParam = {
    Code: '',
    RegisterSys: 1,
    RegisterType: 0,
    Purpose: OAuthPurposeType.AddAccountFromWeb
  };
  message: string;
  config = {
    leftTime: 300,
    template: '$!m!:$!s!',
  };
  private widgetId: number | undefined; // 用於儲存 reCAPTCHA widget ID
  private recaptchaResponse: string | null = null;
  constructor(private fb: FormBuilder,
    private store: Store<fromStore.State>,
    private router: Router,
    // private apiService: DevicesService,AccountService,
    private ngxService: NgxUiLoaderService,
    private cryptoService: CryptoService,
    private messageService: MessageService,
    private apiService: AccountService,
    private preferenceService: PreferenceService,
    private summaryService: SummaryService,
    // private jwtHelper: JwtHelperService,
    private userService: UserService,
    private http: HttpClient,
    private ngZone: NgZone,
    private el: ElementRef // 用於更可靠地獲取元件內的元素
  ) {
    this.summaryService.SetSummaryStartDate = 0;
    this.summaryService.SetSummaryEndDate = 0;

    // this.store.select(fromStore.getCurrentUser)
    //   .subscribe(res => {
    //     if (res.isLoading) {
    //       this.isLogging = true;
    //     } else {
    //       this.isLogging = false;
    //       // this.ngxService.stop();
    //     }
    //     const pathname = window.location.pathname;
    //     if (res.isLogin && pathname === '/login') {
    //       this.store.dispatch(new fromFeature.GetPreferences());
    //       this.store.select(fromStore.getPreferences).pipe(takeUntil(this.componentDestroyed)).subscribe(Preferres => {
    //         if (Preferres.Loaded && !Preferres.Loading) {
    //           if (Preferres.entities != null) {
    //             if (Preferres.entities.DefaultHomePage != null && Preferres.entities.DefaultHomePage !== undefined) {
    //               this.preferenceService.SetDefaultHomePage = Preferres.entities.DefaultHomePage;
    //             }
    //           }
    //         }
    //       });
    //       this.router.navigate(['/index']);
    //       // console.log('success');
    //       // alert('Success!!');
    //     } else if (!res.isLogin && res.isLoaded && !res.isLoading) {
    //       if (res.Message.includes('lock')) {
    //         this.loginFail = true;
    //         this.LoginLockedMessage = res.Message;
    //         this.LoginLocked = true;
    //       }
    //       // console.log('fail');
    //       // alert('Error!!');
    //     }
    //   });

    // 合併原本 login() 也有 subscribe 的 "fromStore.getCurrentUser", 避免重複執行工作
    this.store.select(fromStore.getCurrentUser).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.isLoading) {
        this.isLogging = true;
      } else {
        this.isLogging = false;
        // this.ngxService.stop();
      }
      const pathname = window.location.pathname;
      if (res.isLogin && pathname === '/login') {
        // this.store.dispatch(new fromFeature.GetPreferences());

        if (this.userService.GetRedirect !== 'null' && this.userService.GetRedirect !== null && this.userService.GetRedirect !== '/' &&
         this.userService.GetRedirect !== '/index' && this.userService.GetRedirect !== pathname) {
          this.router.navigate([this.userService.GetRedirect]);
        } else {
          this.router.navigate(['/index']);
        }
      } else if (!res.isLogin && res.isLoaded && !res.isLoading && res.Message !== '') {
        this.loginFail = true;
        // 2026-06-16 移除reCAPTCHA 供v1.10.4測試
        // grecaptcha.reset(this.widgetId); // 重設 reCAPTCHA
        if (res.Message && res.Message.includes('lock')) {
          this.LoginLockedMessage = res.Message;
          this.LoginLocked = true;
        }
      }
    });

    // 從原本 subscribe 的 fromStore.getCurrentUser 拉出來的, 以避免重複訂閱 "fromStore.getPreferences"
    this.store.select(fromStore.getPreferences).pipe(takeUntil(this.componentDestroyed)).subscribe(Preferres => {
      if (Preferres.Loaded && !Preferres.Loading) {
        if (Preferres.entities != null) {
          if (Preferres.entities.DefaultHomePage != null && Preferres.entities.DefaultHomePage !== undefined) {
            this.preferenceService.SetDefaultHomePage = Preferres.entities.DefaultHomePage;
            if (Preferres.entities.DefaultHomePage === 1) {
              if (this.userService.GetRedirect === null) { // 以防自動導向的功能失效
                this.router.navigate(['/globalmap']);
              }
            }
          }
        }
      }
    });

    this.store.select(fromStore.getOauthLogin).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.Loading && !res.Loaded) {
        this.ngxService.start();
      }
      if (res.Loaded && !res.Loading) {
        if (!res.entities.Flag) {

          if (Number(res.entities.Message) === OAuthLoginMessage.AddAccountAvailable) {
            this.AddOauthparam = {
              ...this.AddOauthparam,
              Platform: res.entities.Platform,
              PId: res.entities.PId,
              Email: res.entities.Email,
              FirstName: res.entities.FirstName,
              LastName: res.entities.LastName,
            };
            this.socialEmailRegisterAlert = true;
            // this.registerAccountWithSocial();
          } else if (Number(res.entities.Message) === OAuthLoginMessage.HasAnotherPlatform) {
            this.socialAccountCombineLimitAlert = true;
          } else if (Number(res.entities.Message) === OAuthLoginMessage.SameEmailExist) {
            this.socialAccountEmailAlert = true;
            this.censoredEmail = res.entities.Email;
          }
          if (res.entities.Message.toString().includes('lock')) {
            this.LoginLockedMessage = res.entities.Message.toString();
            this.LoginLocked = true;
          }
        }
        this.ngxService.stop();
      }
    });

    this.store.select(fromStore.getAuthotp).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.Loaded && !res.Loading) {
        // 2026-06-16 移除reCAPTCHA 供v1.10.4
        // grecaptcha.reset(this.widgetId); // 重設 reCAPTCHA
        if (res.entities) {
          if (res.entities.Flag) {
            this.TwoFactorAuthDialog = true;
            this.dialogSaveDirty = false;
            this.OTPOvertime = false;
            this.OTPNumberSubmitDisabled = true;
            this.AuthOtpId = res.entities.Id;
            this.AuthUserotp = res.entities.otp;
            this.OTPNumber = '';
            this.errorMsg = '';
          } else {
            this.OTPLockDialog = true;
          }
        } else {
          // API 回傳空 payload 時避免觸發 null 讀取錯誤
          this.loginFail = true;
          this.errorMsg = '';
        }
        this.ngxService.stop();
      } else if (!res.Loaded && res.Loading) {
        if (res.entities && typeof res.entities.message === 'string') {
          this.message = res.entities.message;
        } else {
          this.message = '';
        }
      }
    });

    this.store.select(fromStore.getCheckAuthOtp).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.Loaded && !res.Loading) {
        if (res.entities?.Flag) {
        } else {
          const errorCode = res.entities?.Message;
          this.errorMsg = CheckAuthOtpErrMsg[errorCode] || '';
          if (errorCode === '1' || errorCode === '2') {
            this.OTPOvertime = true;
            if (errorCode === '1') {
              this.errorMsgByLock = true;
            }
            this.ngxService.stop();
          }
          this.dialogSaveDirty = true;
          this.ngxService.stop();
        }
      }
    });
  }


  ngOnInit() {
    // this.ngxService.start();
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-login');
    body.classList.remove('body-landing');
    body.classList.remove('mobile-toggle');
    body.classList.remove('body-help');
    body.classList.remove('body-addDevice');

    this.form = this.fb.group({
      username: ['', Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$')],
      password: ['', Validators.pattern('^[a-zA-Z0-9-_]{5,20}')],
      rememberMe: [true]
    });

    this.apiService.ReadCountryList().subscribe(res => {
      if (res !== null) {
        const opt = res.map(function (e) {
          return { label: e, value: e };
        });
        this.CountryOptions = this.CountryOptions.concat(opt);
      }
    });
    // 2026-06-16 移除reCAPTCHA 供v1.10.4測試
    // (window as any).ngRecaptchaLoaded = this.ngRecaptchaLoaded.bind(this);
    // this.ngxService.stop();
  }

  ngAfterViewInit(): void {
    // 2026-06-16 移除reCAPTCHA 供v1.10.4測試
    // // 如果 API 已載入且 widget 尚未渲染，則進行渲染 確保 grecaptcha 可用
    // if (typeof grecaptcha !== 'undefined' && grecaptcha.render && this.widgetId === undefined) {
    //   this.renderRecaptcha();
    // }
  }

  // 修正離開 login 頁面後沒有 destory component 的錯誤, 可避免登入登出後, 重複 subscribe 的問題
  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
    // 清理，移除全域回呼
    // 2026-06-16 移除reCAPTCHA 供v1.10.4測試
    // if ((window as any).ngRecaptchaLoaded) {
    //   delete (window as any).ngRecaptchaLoaded;
    // }
    // 如果 widget 存在，考慮是否需要清理 reCAPTCHA 實例
    // 通常 reCAPTCHA API 會自行處理，但如果遇到問題可以嘗試
    // if (this.widgetId !== undefined && typeof grecaptcha !== 'undefined') {
    //    grecaptcha.reset(this.widgetId); // 重設
    // }
  }

  get username() { return this.form.get('username'); }
  get password() { return this.form.get('password'); }


  handleEvent(e) {
    // console.log(e);
    if (e.left <= 0) {
      this.errorMsg = CheckAuthOtpErrMsg[2];
      this.OTPOvertime = true;
    }
  }

  // login() {
  //   // this.ngxService.start();
  //   // console.log(this.cryptoService.hashHmacSha512([6539, 6527, 8770, 8785, 6530]));
  //   this.store.dispatch(new fromStore.LoginAction(this.form.value));
  //   this.store.select(fromStore.getCurrentUser)
  //     .subscribe(res => {
  //       if (res.isLoading) {
  //         this.isLogging = true;
  //       } else {
  //         this.isLogging = false;
  //         // this.ngxService.stop();
  //       }
  //       const pathname = window.location.pathname;
  //       if (res.isLogin && pathname === '/login') {
  //         // tslint:disable-next-line:max-line-length
  //         if (this.userService.GetRedirect !== 'null' && this.userService.GetRedirect !== null && this.userService.GetRedirect !== '/' &&
  //          this.userService.GetRedirect !== '/index' && this.userService.GetRedirect !== pathname) {
  //           this.router.navigate([this.userService.GetRedirect]);
  //         } else {
  //           this.router.navigate(['/index']);
  //         }
  //         // console.log('success');
  //         // alert('Success!!');
  //       } else if (!res.isLogin && res.isLoaded && !res.isLoading) {
  //         this.loginFail = true;
  //         if (res.Message.includes('lock')) {
  //           this.LoginLockedMessage = res.Message;
  //           this.LoginLocked = true;
  //         }
  //         // console.log('fail');
  //         // alert('Error!!');
  //       }
  //     });
  //   // this.apiService.getDeviceDetails('abcdefghijkl', 'f75d7014a776000b1d366672bcb7688f').subscribe(res => {
  //   //   console.log(res);
  //   // });
  // }

  login() {
    this.store.dispatch(new fromStore.LoginAction({ ...this.form.value }));
    // 2026-06-16 移除reCAPTCHA 供v1.10.4測試
    // 檢查 widgetId 是否存在
    // if (this.widgetId === undefined) {
    //     this.reCAPTCHAFail = true;
    //     // 可以嘗試再次渲染，或提示用戶刷新
    //     if (typeof grecaptcha !== 'undefined' && grecaptcha.render) {
    //       this.renderRecaptcha(); // 嘗試重新渲染
    //     }
    //     return;
    // }

    // this.reCAPTCHAFail = false;

    // // 如果之前有 token 且未過期，可以直接使用 (可選邏輯)
    // // if (this.recaptchaResponse) {
    // //   this.proceedWithLogin(this.recaptchaResponse);
    // // } else {
    // //   // 執行 reCAPTCHA
    // //   grecaptcha.execute(this.widgetId);
    // // }
    // // 總是執行 reCAPTCHA 以獲取最新的 token
    // grecaptcha.execute(this.widgetId);
  }

  closeDialog() {
    this.isLogging = false;
    this.LoginLocked = false;
    this.TwoFactorAuthDialog = false;
  }

  handleChange(e: any) {
    const isChecked = e.checked;
    if (isChecked) {
      this.inputType = 'text';
    } else {
      this.inputType = 'password';
    }
  }

  OTPkeyupEnter(e) {
    if (this.OTPNumber.length >= 6) {
      this.confrimOTPnumber();
    }
  }

  OTPNumberOnchange($event) {
    const OTPNumberLength = $event.replaceAll('_', '');
    if (OTPNumberLength.length >= 6) {
      this.OTPNumberSubmitDisabled = false;
    } else {
      this.OTPNumberSubmitDisabled = true;
    }
  }

  passwordChange(password: string) {
    if (password.length > 0) {
      this.showPasswordIcon = true;
    } else if (password.length === 0) {
      this.showPasswordIcon = false;
      this.inputType = 'password';
    }
  }

  socialLogin(socialType) {
    this.socialType = socialType;

    if (socialType === 'apple') {
      // tslint:disable-next-line:max-line-length
      let url = environment.PowerPanelCloudAppleOAuthUrl.replace('{0}', environment.RedirectAuthApiUrl);
      url = url.replace('{1}', '&state=login');
      window.location.href = url;
    }
    if (socialType === 'google') {
      let url = environment.PowerPanelCloudGoogleOAuthUrl.replace('{0}', environment.HomePageUrl);
      url = url.replace('{1}', '');
      window.location.href = url;
    }
    // 2026/07/21 kyrie.hung 移除 Facebook 登入功能
    // if (socialType === 'facebook') {
    //   let url = environment.PowerPanelCloudFacebookOAuthUrl.replace('{0}', environment.HomePageUrl);
    //   url = url.replace('{1}', '');
    //   window.location.href = url;
    // }
  }

  registerAccountWithOtherMail() {
    this.router.navigate(['/login']);
    this.socialEmailRegisterAlert = false;
  }

  registerAccountWithSocial() {
    this.socialEmailRegisterAlert = false;
    this.socialEmailRegisterSetting = true;
    this.Country = null;
  }

  checkRegisterAccountSave() {
    if (!this.Country) {
      return true;
    }
    return false;
  }

  registerAccountSettingSave() {
    this.socialEmailRegisterSetting = false;
    this.AddOauthparam = {
      ...this.AddOauthparam,
      Country: this.Country,
    };
    this.store.dispatch(new fromFeature.AddAccountByOauth({ ...this.AddOauthparam }));
    // if (true) {
    //   console.log(this.Country);
    //   console.log('用該AFG帳號新增一個PPC帳號');
    //   this.messageService.add({ severity: 'success', summary: 'You have logged in with the social account successfully!' });
    //   this.socialEmailRegisterSetting = false;
    // }
  }

  confrimOTPnumber() {
    this.ngxService.start();
    const param = {
      otp: this.AuthUserotp,
      authId: Number(this.AuthOtpId),
      authType: AuthOtpType.Login,
      authOtp: this.OTPNumber,
    };
    this.store.dispatch(new fromFeature.CheckAuthOtp(param));
  }

  routerSSO() {
    this.router.navigate(['/login/sso']);
  }

  
  // 2026-06-16 移除reCAPTCHA 供v1.10.4測試
  // ngRecaptchaLoaded(): void {
  //   this.ngZone.run(() => {
  //     if (typeof grecaptcha !== 'undefined' && grecaptcha.render) {
  //       this.renderRecaptcha();
  //     }
  //   });
  // }

  // renderRecaptcha(): void {
  //   if (this.widgetId !== undefined) {
  //     return;
  //   }
  //   const siteKey = RECAPTCHA_V2_INVISIBLE_SITE_KEY;

  //   try {
  //     this.widgetId = grecaptcha.render(document.getElementById('loginButton'), {
  //       'sitekey': siteKey,
  //       'badge': 'bottomright', // 'bottomright', 'bottomleft', 'inline'
  //       'size': 'invisible',
  //       'callback': this.onRecaptchaSuccess.bind(this), // 成功時的回呼
  //       'expired-callback': this.onRecaptchaExpired.bind(this), // token 過期時的回呼
  //       'error-callback': this.onRecaptchaError.bind(this) // 發生錯誤時的回呼
  //     });
  //     // console.log('reCAPTCHA widget rendered, ID:', this.widgetId);
  //   } catch (error) {
  //     // console.error('Error rendering reCAPTCHA:', error);
  //   }
  // }

  // onRecaptchaSuccess(token: string): void {
  //   this.ngZone.run(() => {
  //     this.recaptchaResponse = token;
  //     this.proceedWithLogin(token);
  //   });
  // }

  // onRecaptchaExpired(): void {
  //   this.ngZone.run(() => {
  //     this.recaptchaResponse = null;
  //     grecaptcha.reset(this.widgetId); // 重設 reCAPTCHA
  //   });
  // }

  // onRecaptchaError(): void {
  //   this.ngZone.run(() => {
  //     this.recaptchaResponse = null;
  //     this.reCAPTCHAFail = true;
  //     grecaptcha.reset(this.widgetId); // 重設 reCAPTCHA
  //   });
  // }

  proceedWithLogin(recaptchaToken: string): void {
    const credentials = {
      recaptchaToken: recaptchaToken
    };

    // 將資料發送到後端與google交握驗證資料是否合法
    this.http.post('/api/login/recaptcha', credentials).subscribe(res => {
      if (res && res['success']) {
        this.store.dispatch(new fromStore.LoginAction({ ...this.form.value }));
      } else {
        this.reCAPTCHAFail = true;
      }
    });
  }
}
